import { cn } from "@newxsystems/shared";
import { GroundAction } from "../GroundAction/GroundAction";
import { GroundMedia } from "../GroundMedia/GroundMedia";
import { GroundRichText } from "../GroundRichText/GroundRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";
  return (
    <div className="relative flex min-h-[38rem] overflow-hidden bg-charcoal-green-ink md:min-h-[46rem]">
      <GroundMedia
        className="absolute inset-0 h-full"
        imageClassName="object-cover"
        media={image.image}
        priority
        sizes="(min-width: 1536px) 1440px, calc(100vw - 48px)"
      />
      <div className="absolute inset-0 bg-charcoal-green-ink/35" />
      <div className="relative z-10 flex w-full items-end p-5 md:p-10 lg:p-14">
        <div
          className={cn(
            "w-full max-w-[58rem] border-t border-mineral-gray/50 bg-charcoal-green-ink p-6 text-mineral-gray md:p-10",
            centered && "mx-auto text-center",
          )}
        >
          <div className={cn("flex flex-col gap-5", centered && "items-center")}>
            {eyebrow ? <p className="font-ground-mono text-xs">{eyebrow}</p> : null}
            {heading ? (
              <h1 className="font-ground-display text-[clamp(1.875rem,9.25vw,5.5rem)] font-bold leading-[0.92] tracking-[-0.03em] text-balance [overflow-wrap:normal] [word-break:normal] hyphens-none md:text-7xl lg:text-8xl">
                {heading}
              </h1>
            ) : null}
            {description ? (
              <GroundRichText className="max-w-[60ch] text-mineral-gray" content={description} />
            ) : null}
            {buttons?.length ? (
              <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
                {buttons.map((button, index) => (
                  <GroundAction
                    action={button}
                    className="border-mineral-gray text-mineral-gray"
                    key={`${button.href}-${index}`}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
